


























import { Component, Prop, Vue } from "@/shared/vuepack";
import HsabExpenseForm from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseForm.vue";
import { HsabExpenseFormMode, HsabExpenseFormType } from "@/shared/types";
import { useThemeStore } from "@/shared/store/theme";
import HsabExpenseCardRowExpanded
  from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseCardRowExpanded.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import HsabExpenseReimbursementStatusPill
  from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseReimbursementStatusPill.vue";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";

@Component({
  components: {
    HsabExpenseReimbursementStatusPill,
    HsabExpenseCardRowExpanded,
    HsabExpenseForm,
    GenericLoadingSpinner,
  }
})
export default class HsabExpenseDetailsModal extends Vue {
  themeStore = useThemeStore();
  hsabExpenseFormStore = useHsabExpenseFormStore();

  @Prop()
  hsabExpenseFormType: HsabExpenseFormType;

  get showModal () {
   return this.hsabExpenseFormStore.modalMode === HsabExpenseFormMode.reviewSubmission;
  }

  handleOnEditClose () {
    if (this.hsabExpenseFormStore.modalMode === HsabExpenseFormMode.reviewSubmission) {
      this.hsabExpenseFormStore.updateModalMode(HsabExpenseFormMode.none);
    }
  }
}
